import styled from 'styled-components';

const css = {};

css.NotLogin = styled.div`
  display: flex;
  align-items: center;
`;

css.TextWrapper = styled.div`
  &:not(:last-child) {
    margin-right: 17px;
  }
`;

css.Text = styled.span`
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.44);
`;

css.ColorText = styled(css.Text)`
  color: rgba(59, 250, 194, 1);
`;

css.UnderlineColorText = styled(css.ColorText)`
  text-decoration: underline;
`;

export default css;
